import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import ReactGA from 'react-ga';
import './utils/i18n';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import SprawneMiastoContext from './components/SprawneMiastoContext';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorPage from './components/ErrorPage';
import { ThemeProvider } from '@mui/material';
import theme from './mui.theme';
import { APIProvider } from '@vis.gl/react-google-maps';

ReactGA.initialize('G-DR8DZP6F2F');
ReactGA.pageview(window.location.pathname + window.location.search);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    // <React.StrictMode>
    <ErrorBoundary fallback={<ErrorPage />}>
        <GoogleReCaptchaProvider reCaptchaKey={'6LeM9ZMjAAAAABIxAnEFOQ7L8oCHOAiWYVyzzn4W'}>
            <BrowserRouter>
                <APIProvider
                    libraries={['places', 'geometry', 'geocoding']}
                    apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string}>
                    <SprawneMiastoContext>
                        <ThemeProvider theme={theme}>
                            <App />
                        </ThemeProvider>
                    </SprawneMiastoContext>
                </APIProvider>
            </BrowserRouter>
        </GoogleReCaptchaProvider>
    </ErrorBoundary>,
    // </React.StrictMode>,
);
